// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-special-effects-container {
  border-top: 1px solid #e0e0e0;
  padding: 16px;
}
.font-special-effects-container .button-group .font-special-effects-btn {
  width: 32px;
  height: 30px;
}
.font-special-effects-container .button-group .font-special-effects-btn-selected {
  background: white;
}
.font-special-effects-container .line-between {
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.font-special-effects-container .margin-left-8 {
  margin-left: 8px;
}
.font-special-effects-container .margin-right-6 {
  margin-right: 6px;
}
.font-special-effects-container .btn-down-outlined {
  padding: 2px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/FontSpecialEffetcs/index.less"],"names":[],"mappings":"AAAA;EAEI,6BAAA;EACA,aAAA;AAAJ;AAHA;EAOY,WAAA;EACA,YAAA;AADZ;AAPA;EAYY,iBAAA;AAFZ;AAVA;EAiBQ,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAJR;AAhBA;EAwBQ,gBAAA;AALR;AAnBA;EA4BQ,iBAAA;AANR;AAtBA;EAgCQ,gBAAA;AAPR","sourcesContent":[".font-special-effects-container {\n\n    border-top: 1px solid #e0e0e0;\n    padding: 16px;\n\n    .button-group {\n        .font-special-effects-btn {\n            width: 32px;\n            height: 30px;\n        }\n\n        .font-special-effects-btn-selected {\n            background: white;\n        }\n    }\n\n    .line-between {\n        margin: 8px 0;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .margin-left-8 {\n        margin-left: 8px;\n    }\n\n    .margin-right-6 {\n        margin-right: 6px;\n    }\n\n    .btn-down-outlined {\n        padding: 2px 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
